import React, { useState, useEffect, useRef, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { MdAlternateEmail } from "react-icons/md";
import { MdPermContactCalendar } from "react-icons/md";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import Switch from "react-switch";
import { IoIosCall } from "react-icons/io";
import ChatInfo from "./ToolChatInfo";
import "./GuideInfo.css";
import { postUserInfo, postChatInfo } from "../../redux/userInfo/userAction";
import GrantModal from "../modal/grantModal/grantModal";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Modal from "../modal/Modal";
import NetworkLoader from "../NetworkLoader";
import { debounce } from "lodash";
import dayjs from "dayjs";

const allowedCountries = ["NG", "KE", "ET"];

const customerSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup.string().required("Phone number is required"),
});

const newCustomerSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("invalid email").required("Email is required"),
  phone: yup.string().required("Phone number is required"),
  hospital: yup.string().required("Hospitals is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  date: yup.string().required("Date is required"),
  time: yup.string().required("Time is required"),
  mode: yup.string().required("Mode is required"),
  supplies: yup.string().required("Supplies is required"),
  frequency: yup.string().required("Frequency is required"),
  amounts: yup.string().required("Amounts is required"),
  value: yup.string().required("Value is required"),
  feedback: yup.string().required("Feedback is required"),
  checked: yup.boolean(),
});

const validatePhoneNumber = (phoneNumber, countryCallingCode) => {
  console.log(phoneNumber, countryCallingCode);
  if (countryCallingCode === "+251" && phoneNumber.length === 12) {
    return true;
  } else if (countryCallingCode === "+234" && phoneNumber.length === 10) {
    return true;
  } else if (countryCallingCode === "+254" && phoneNumber.length === 9) {
    return true;
  } else {
    return false;
  }
};
const GuideInfo = () => {
  const dispatch = useDispatch();
  const ModalRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qValue = queryParams.get("q");

  const readUrl = `https://one.lifebank.ng/api/v1/marketing/guide/read/${qValue}`;

  const appointmentUrl = `https://one.lifebank.ng/api/v1/marketing/guide/appointment/${qValue}`;

  // const readUrl = `https://one.lifebanktest.com/v1/marketing/guide/read/${qValue}`;

  // const appointmentUrl = `https://one.lifebanktest.com/v1/marketing/guide/appointment/${qValue}`;

  const [isOpen, setIsOpen] = useState(false);
  const [userGuideInfo, setUserGuideInfo] = useState({
    name: "",
    email: "",
    phone: "",
    q: qValue,
  });
  const [chatData, setChatData] = useState({
    name: userGuideInfo.name,
    email: userGuideInfo.email,
    phone: "",
    hospital: "",
    city: "",
    state: "",
    date: "",
    time: "",
    mode: "",
    supplies: "",
    frequency: "",
    amounts: "",
    value: "",
    feedback: "",
    q: qValue,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [chatEnabled, setChatEnabled] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [emailValid, setEmailValid] = useState(true);
  const [value, setPhoneNumber] = useState();
  const [databaseValidator, setDatabaseValidator] = useState(false);

  const validationSchema = [customerSchema, newCustomerSchema];
  const currentValidationSchema = validationSchema[activeStep];

  const [isLoading, setIsLoading] = useState(false);

  const verifyCustomer = useCallback(
    async function (params) {
      const { email, phone } = params;
      console.log(phone);
      try {
        setIsLoading(true);
        const response = await axios.post(
          `https://one.lifebank.ng/api/v1/marketing/quick/check/guide`,
          {
            email: email,
            phone: phone,
          }
        );
        // const response = await axios.post(
        //   `https://one.lifebanktest.com/v1/marketing/quick/check/guide`,
        //   {
        //     email: email,
        //     phone: phone,
        //   }
        // );
        const itExists = response.data.data;
        if (itExists) {
          setDatabaseValidator(itExists);
          return itExists;
        }
        if (!chatEnabled && !itExists) ModalRef.current.openModal();
      } catch (error) {
        console.error("Error in verifying email:", error);
      } finally {
        setIsLoading(false); // Set isLoading to false after the request is completed
      }
    },
    [chatEnabled]
  );
  const {
    control,
    register,
    handleSubmit: registerForm,
    formState: { errors },
    trigger,
    watch,
    setValue,
    reset,
    setError,
  } = useForm({
    mode: "onchange",
    resolver: yupResolver(currentValidationSchema),
  });

  const watchPhone = watch("phone");

  // useEffect(() => {
  //   if (watchPhone === undefined) return;

  //   let phoneNumber = "";
  //   let countryCode = "";
  //   const phoneObj = parsePhoneNumber(watchPhone);
  //   if (phoneObj && phoneObj.countryCallingCode) {
  //     const { countryCallingCode, nationalNumber } = phoneObj;
  //     phoneNumber = nationalNumber;
  //     countryCode = `+${countryCallingCode}`;
  //   }
  //   const debounced = debounce(async () => {
  //     if (watchPhone) {
  //       const isValidPhoneNumber = validatePhoneNumber(
  //         phoneNumber,
  //         countryCode
  //       );
  //       if (isValidPhoneNumber) {
  //         setError("phone", {
  //           type: "server",
  //           message: "",
  //         });
  //         // await verifyCustomer({ email: watchEmail, phone: phoneNumber });
  //         // return;
  //       } else {
  //         console.log("Invalid phone number");
  //         setError("phone", {
  //           type: "server",
  //           message: "Invalid phone number",
  //         });
  //         // setDatabaseValidator(false);
  //       }
  //     }
  //   }, 1000);
  //   debounced();
  //   return () => {
  //     debounced.cancel();
  //   };
  // }, [watchPhone]);

  const handleNextValidation = async () => {
    if (chatEnabled === true) {
      const isCurrentFormValid = await trigger();
      console.log(isCurrentFormValid);
      if (isCurrentFormValid) {
        setActiveStep((currentStep) => currentStep + 1);
      }
    }
  };
  console.log(!databaseValidator && chatEnabled);
  useEffect(() => {
    handleNextValidation();
  }, [chatEnabled]);

  const onSubmit = async (data) => {
    console.log(data);

    const phoneObj = parsePhoneNumber(data.phone);
    if (phoneObj && phoneObj.countryCallingCode) {
      const { countryCallingCode, nationalNumber } = phoneObj;
      data.countrycode = `+${countryCallingCode}`;
      data.phone = nationalNumber;
    }

    if (data.phone) {
      const isValidPhoneNumber = validatePhoneNumber(
        data.phone,
        data.countrycode
      );
      if (isValidPhoneNumber) {
        setError("phone", {
          type: "server",
          message: "",
        });
      } else {
        setError("phone", {
          type: "server",
          message: "Invalid phone number",
        });
        return;
        // setDatabaseValidator(false);
      }
    }
    const withId = {
      ...data,
      q: qValue,
    };

    const payload = {
      ...withId,
      date: dayjs(data.date).format("YYYY-MM-DD"),
    };
    if (!chatEnabled) {
      await verifyCustomer({ email: data.email, phone: data.phone }).then(
        async (response) => {
          if (response) {
            const response = await axios.post(readUrl, withId);
            console.log(response);
            if (response.data.message !== "Access Granted to This File") {
              setIsOpen(false);
              return notified();
            } else {
              setIsOpen(true);
              const redirectUrl = `https://${response.data.data}`;

              setTimeout(() => {
                window.open(redirectUrl, "_blank");
              }, 3000);
            }
            reset();
            setDatabaseValidator(false);
          }

          //  else if (chatEnabled) {
          //   const res = await axios.post(appointmentUrl, payload);
          //   console.log(res);
          //   if (res.data.message !== "Access Granted to This File") {
          //     setIsOpen(false);
          //     return notified();
          //   } else {
          //     setIsOpen(true);
          //     const redirectUrl = `https://${res.data.data}`;
          //     setTimeout(() => {
          //       window.open(redirectUrl, "_blank");
          //     }, 3000);
          //   }
          //   reset();
          //   setDatabaseValidator(false);
          // }
        }
      );
      return;
    }

    setIsLoading(true);
    try {
      if (chatEnabled) {
        const res = await axios.post(appointmentUrl, payload);
        console.log(res);
        if (res.data.message !== "Access Granted to This File") {
          setIsOpen(false);
          return notified();
        } else {
          setIsOpen(true);
          const redirectUrl = `https://${res.data.data}`;
          setTimeout(() => {
            window.open(redirectUrl, "_blank");
          }, 3000);
        }
        reset();
        setDatabaseValidator(false);
      }
    } catch (e) {
      console.error("Error in submitting form:", e);
    } finally {
      setIsLoading(false);
    }

    // try {
    //   // setIsLoading(true); // Set isLoading to true before making the request

    //   if (!chatEnabled && databaseValidator) {
    //     const response = await axios.post(readUrl, withId);
    //     console.log(response);
    //     if (response.data.message !== "Access Granted to This File") {
    //       setIsOpen(false);
    //       return notified();
    //     } else {
    //       setIsOpen(true);
    //       const redirectUrl = `https://${response.data.data}`;

    //       setTimeout(() => {
    //         window.open(redirectUrl, "_blank");
    //       }, 3000);
    //     }
    //     reset();
    //     setDatabaseValidator(false);
    //   } else if (chatEnabled && !databaseValidator) {
    //     const res = await axios.post(appointmentUrl, payload);
    //     console.log(res);
    //     if (res.data.message !== "Access Granted to This File") {
    //       setIsOpen(false);
    //       return notified();
    //     } else {
    //       setIsOpen(true);
    //       const redirectUrl = `https://${res.data.data}`;
    //       setTimeout(() => {
    //         window.open(redirectUrl, "_blank");
    //       }, 3000);
    //     }
    //     reset();
    //     setDatabaseValidator(false);
    //   }
    // } catch (error) {
    //   console.error("Error in submitting form:", error);
    // } finally {
    //   setIsLoading(false); // Set isLoading to false after the request is completed
    // }
  };

  const notify = () => toast.error("Please enter your email and phone number");
  const notified = () =>
    toast.error("SORRY YOU ARE NOT AUTHORISED TO ACCESS THIS QUICK GUIDE");
  const notification = () =>
    toast.error("SORRY YOU ARE NOT AUTHORISED TO ACCESS THIS QUICK GUIDE");
  const fill = () => toast.error("Please complete all the required fields");

  const handlePhoneChange = (newPhone) => {
    const formattedPhone = formatPhoneNumberIntl(newPhone);
    const phoneObj = parsePhoneNumber(formattedPhone);
    if (phoneObj && phoneObj.countryCallingCode) {
      const { countryCallingCode, nationalNumber } = phoneObj;
      setPhoneNumber(formattedPhone);
      setFormValues((prevState) => ({
        ...prevState,
        phone: nationalNumber,
        countrycode: `+${countryCallingCode}`,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        phone: isValidPhoneNumber(formattedPhone) ? "" : "Invalid phone number",
      }));

      // Now, update userGuideInfo as well
      setUserGuideInfo((userGuideInfo) => ({
        ...userGuideInfo,
        phone: nationalNumber,
        countrycode: `+${countryCallingCode}`,
      }));

      setChatData((chatData) => ({
        ...chatData,
        phone: nationalNumber,
        countrycode: `+${countryCallingCode}`,
      }));
      setValue("phone", nationalNumber);
      console.log(isValidPhoneNumber(nationalNumber));
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        phone: "Invalid phone number",
      }));
      setDatabaseValidator(false);
    }
  };

  const isValidEmail = (email) => {
    // Regular expression for email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleSwitchToggle = () => {
    setChatEnabled(!chatEnabled);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserGuideInfo({
      ...userGuideInfo,
      [name]: value,
    });
    setFormValues((prevState) => ({ ...prevState, [name]: value }));
    setFormErrors((prevState) => ({ ...prevState, [name]: "" }));
    updateLocalStorage({ ...formValues, [name]: value });

    if (name === "email") {
      if (isValidEmail(value)) {
        setEmailValid(true);
        console.log(value);
        // verifyEmail();
      } else {
        setEmailValid(false);
      }
    }

    setChatData({
      ...chatData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!userGuideInfo.email && !userGuideInfo.phone) {
      notify();
      return;
    }

    if (!chatData.hospital && chatEnabled) {
      notified();
      setTimeout(() => {
        // navigate("/");
      }, 5000);
      return;
    }

    if (
      chatEnabled &&
      (!chatData.hospital ||
        !chatData.city ||
        !chatData.state ||
        !chatData.date ||
        !chatData.time ||
        !chatData.mode ||
        !chatData.supplies ||
        !chatData.frequency ||
        !chatData.amounts ||
        !chatData.value ||
        !chatData.feedback)
    ) {
      fill();
      setIsOpen(false);
      return;
    }

    // setIsOpen(true);

    const infoAppointment = async () => {
      try {
        // toast.info('Loading...');
        // const readUrl = `https://one.lifebanktest.com/v1/marketing/guide/read/${qValue}`;
        // const appointmentUrl = `https://one.lifebanktest.com/v1/marketing/guide/appointment/${qValue}`;

        // const readUrl = `https://one.lifebank.ng/api/v1/marketing/guide/read/${qValue}`;
        // const appointmentUrl = `https://one.lifebank.ng/api/v1/marketing/guide/appointment/${qValue}`;

        const [readResponse, appointmentResponse] = await Promise.all([
          !chatEnabled
            ? await axios.post(readUrl, userGuideInfo)
            : chatEnabled
              ? await axios.post(appointmentUrl, chatData)
              : null,
        ]);
        // toast.dismiss();

        if (readResponse.data && readResponse.data.data) {
          const readData = readResponse.data.data;

          if (readResponse.data.message !== "Access Granted to This File") {
            setIsOpen(false);
            return notified();
          } else {
            console.log("responseooo", readResponse);
            setIsOpen(true);
            window.open(readData, "_blank");
          }

          // Close the new tab and navigate after 5 seconds
          setTimeout(() => {
            // navigate("/");
          }, 5000);
        } else {
          console.error("No data received from the read API endpoint.");
        }

        if (
          chatEnabled &&
          appointmentResponse &&
          appointmentResponse.data &&
          appointmentResponse.data.data &&
          chatEnabled !== readResponse
        ) {
          const appointmentData = appointmentResponse.data.data;
          // window.open(appointmentData, "_blank");

          // Close the new tab and navigate after 5 seconds
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          console.error("No data received from the appointment API endpoint.");
        }
      } catch (error) {
        console.error("Error in API requests:", error);
      }
    };

    infoAppointment();

    setUserGuideInfo({
      ...userGuideInfo,
      name: "",
      email: "",
      phone: "",
    });

    setChatData({
      ...chatData,
      ...userGuideInfo,
      hospital: "",
      city: "",
      state: "",
      date: "",
      time: "",
      mode: "",
      supplies: "",
      frequency: "",
      amounts: "",
      value: "",
      feedback: "",
    });

    // console.log("chatData", chatData);
  };

  return (
    <div className="guideCont">
      {isLoading && <NetworkLoader />}
      <div className="h2Text">
        <h2>Fill the form below to access the full guide</h2>
        <div className="arrowDown">
          <IoIosArrowDown />
        </div>
      </div>
      <form onSubmit={registerForm(onSubmit)}>
        <div className="guideContainer">
          <div className="nameEmail">
            <div className="nameBox">
              <div className="nameIcon">
                <MdPermContactCalendar />
              </div>
              <label htmlFor="name" className="nameLabel">
                Your name:
              </label>
              <input
                {...register("name")}
                type="text"
                className="nameInputt"
                id="name"
                name="name"
              />
              <p>
                {errors.name && (
                  <span className="error-message">{errors.name.message}</span>
                )}
              </p>
            </div>
            <div className="emailBox">
              <div className="emailIcon">
                <MdAlternateEmail />
              </div>
              <label htmlFor="email" className="emailLabel">
                Email:
              </label>
              <input
                {...register("email")}
                className={`emailInputt ${!emailValid ? "error-message" : ""}`}
                type="email"
                id="email"
                name="email"
              />{" "}
              <p>
                {errors.email && (
                  <span className="error-message">{errors.email.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="phoneChat">
            <div className="phoneBox">
              <div className="pIcon">
                <IoIosCall />
              </div>
              <label htmlFor="phone" className="phoneLabe">
                Phone Number:
              </label>

              <div className="relative">
                <label htmlFor="phone-input">Phone Number</label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    validate: (value) => isValidPhoneNumber(value),
                  }}
                  render={({ field: { onChange, value } }) => (
                    <PhoneInput
                      value={value}
                      onChange={onChange}
                      addInternationalOption={false}
                      defaultCountry="NG"
                      id="phone"
                      className="phonePutt"
                      countries={allowedCountries}
                      placeholder="+234 123 456 7890"
                    />
                  )}
                />
                <p className="absolute -bottom-5">
                  {errors.phone && (
                    <span className="error-message">
                      {errors.phone.message}
                    </span>
                  )}
                </p>
              </div>
            </div>

            <div className="chatBox">
              <div className="p-div">
                <div className="ph">
                  <p>
                    Would you like to have a chat <br /> with LifeBank?
                  </p>

                  <Switch
                    onChange={handleSwitchToggle}
                    checked={chatEnabled}
                    className="mt-5 ml-5 switch"
                    onColor="#008000"
                    offColor="#ccc"
                    onHandleColor="#fff"
                    offHandleColor="#fff"
                    handleDiameter={20}
                    height={28}
                    width={60}
                    checkedIcon={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          fontSize: "14px",
                          color: "white",
                        }}
                      >
                        Yes
                      </div>
                    }
                    uncheckedIcon={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          fontSize: "14px",
                        }}
                      >
                        No
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {chatEnabled && (
            <ChatInfo
              control={control}
              register={register}
              errors={errors}
              setValue={setValue}
              chatData={chatData}
            />
          )}
          <div className="Btn">
            <button
              className="disabled:opacity-50"
              // disabled={!databaseValidator && !chatEnabled}
              type="submit"
            >
              <div className="b-Icon">
                View Guide
                <div className="ml-3">
                  <BsFillArrowRightCircleFill />
                </div>
              </div>
            </button>
            <Toaster />
          </div>
          {isOpen && (
            <GrantModal
              setIsOpen={setIsOpen}
              title="ACCESS GRANTED!"
              message=" A copy of this Guide has been sent to your provided email"
            />
          )}
        </div>
      </form>
      <Modal ref={ModalRef}>
        <div className="modalContent space-y-5 flex flex-col items-center px-5 text-center">
          <h2>SORRY YOU ARE NOT AUTHORIZED TO ACCESS THIS QUICK GUIDE</h2>
          <p>This guide is only for our customers</p>

          <p>Kindly fill the below form to chat with LifeBank</p>

          <button
            className="bg-blue-500 p-3 rounded-md mx-auto text-white"
            onClick={() => {
              // setNotAuthorized(false);
              setChatEnabled(true);
              ModalRef.current.closeModal();
            }}
          >
            Chat with LifeBank
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default GuideInfo;
